import { CLICK_DESCRIPTION } from 'documents-lib/js/tracking/actions';
import { trackInteraction } from 'documents-lib/js/tracking/tracker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const DescriptionHoverButton = ({
  deckId,
  isLoading,
  deckTitle,
  fetchDocumentDescription,
  toggleDocumentDescription
}) => {
  const handleOnClick = () => {
    toggleDocumentDescription({
      isOpen: true,
      deckId,
      deckTitle
    });
    fetchDocumentDescription({
      deckId
    });
    trackInteraction(CLICK_DESCRIPTION);
  };
  return /*#__PURE__*/_jsx(Button, {
    marginInlineEnd: "300",
    size: "extra-small",
    use: "tertiary-light",
    disabled: isLoading,
    onClick: handleOnClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "table.hoverButtons.description"
    })
  }, "summary");
};
export default DescriptionHoverButton;